import type { NSchedule } from '@app/types/Schedule';

import { adaptTimeRange } from '@pages/WorkSchedule/utils/adaptTimeRange';

export const joinTimeIntervals = (
  schedules: NSchedule.ModelWorkSchedule[],
  specificSchedule: NSchedule.ModelWorkSchedule,
  startTime?: string,
  endTime?: string
) => {
  const { UserId, TimeS } = specificSchedule;
  // Исходим из допущения, что график не может заканчиваться в следующем дне
  const extractDate = (TimeS: string) => TimeS.split('T')[0];
  const timeIntervals = schedules.filter(
    ({ Id, UserId: _UserId, TimeS: _TimeS }: NSchedule.ModelWorkSchedule) => {
      if (
        UserId === _UserId &&
        extractDate(TimeS) === extractDate(_TimeS) &&
        Id !== 0
      ) {
        return true;
      }
    }
  );
  const lastHandlerInterval = adaptTimeRange(
    timeIntervals[timeIntervals.length - 1]?.TimeS,
    timeIntervals[timeIntervals.length - 1]?.TimeE,
    startTime,
    endTime
  );

  return lastHandlerInterval;
};
